export default {
	styleOverrides: {
		gutterBottom: {
			marginBottom: '8px',
		},
	},
};
